<template>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.67 12.9999C2.6331 12.4439 3.72559 12.1511 4.83768 12.1511C5.94978 12.1511 7.04227 12.4439 8.00537 12.9999C8.96847 12.4439 10.061 12.1511 11.1731 12.1511C12.2851 12.1511 13.3776 12.4439 14.3407 12.9999"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.67 3.84878C2.6331 3.29273 3.72559 3 4.83768 3C5.94978 3 7.04227 3.29273 8.00537 3.84878C8.96847 3.29273 10.061 3 11.1731 3C12.2851 3 13.3776 3.29273 14.3407 3.84878"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.67 3.84863V12.9997"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.00539 3.84863V12.9997"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.3407 3.84863V12.9997"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
